import { BooleanField, DateTimeInput, Edit, minValue, required, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

const validateDate = [required(), minValue(new Date())];

export const NotificationEdit = (props: unknown) => (
  <Edit {...props} title={<CustomTitle />}>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="title" />
      <TextInput source="message" />
      <DateTimeInput source="deliveryDate" validate={validateDate} />
      <BooleanField source="delivered" />
    </SimpleForm>
  </Edit>
);
